import { render, staticRenderFns } from "./OpenClosed.vue?vue&type=template&id=33779b90&scoped=true&"
import script from "./OpenClosed.vue?vue&type=script&lang=js&"
export * from "./OpenClosed.vue?vue&type=script&lang=js&"
import style0 from "./OpenClosed.vue?vue&type=style&index=0&id=33779b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33779b90",
  null
  
)

export default component.exports